import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";
import { isDefined } from "@omni/utils/helper.utils";

import { ProductConfigurationDetailComponent } from "@/components/Product/ProductConfigurationDetail/productConfigurationDetail.component";

type ArticleConfigurationComponentProps = {
    item: OrderItem;
};

const ArticleConfigurationComponent = ({
    item
}: ArticleConfigurationComponentProps) => {
    if (!isDefined(item.articleConfiguration)) return null;

    return (
        <ProductConfigurationDetailComponent
            configuration={item.articleConfiguration}
        />
    );
};

export { ArticleConfigurationComponent };
